import { type PageNamesType } from '@/config/ui';

/**
 * Represents a custom error with additional properties.
 */
export class CustomError extends Error {
  code: number; // HTTP status code. Is used to determine the error page and how to handle the error.
  errorPageName?: PageNamesType; // The name of the error page to be shown.

  originalError?: Error;

  constructor(message: string, code: number = 500, errorPageName?: PageNamesType, originalError?: Error) {
    super(message);
    this.name = 'CustomError';
    this.code = code;
    this.errorPageName = errorPageName;
    this.originalError = originalError;
  }
}

export const isNotFoundError = (error: Error | null) =>
  error?.name === 'CustomError' && (error as CustomError).code === 404;
